import React from "react";
import { Link } from "react-router-dom";
import { Heading3 } from "../value-cssmodules/TextComponent";
import styles from "./ThumbnailsProduct.module.scss";

const ThumbnailsProduct = ({ thumb }: any) => {
  return (
    <Link to={`/pattern/${thumb._id || thumb.id || '1'}`} style={{ textDecoration: 'none' }}>
      <section
        className={styles.thumbnailsProduct}
        style={{ backgroundImage: `url(${thumb.url || thumb.image || 'https://via.placeholder.com/270x200'})` }}
      >
        <div className={styles.designerName}>
          <Heading3>{thumb.designer || 'Designer'}</Heading3>
        </div>
        <div className={styles.productTitle}>
          <Heading3>{thumb.title}</Heading3>
          <Heading3>{thumb.price}</Heading3>
        </div>
      </section>
    </Link>
  );
};

export default ThumbnailsProduct;
